/**
 * /login — thin route shim.
 *
 * Everything interesting lives in `features/auth/pages/admin-login-page.tsx`.
 * This file defines the URL, its search-param contract, and wires
 * the page component.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminLoginPage } from "@/features/auth/pages/admin-login-page";

const loginSearchSchema = z.object({
  /**
   * Absolute path to redirect to after a successful login. Populated
   * by the auth guard when an unauthenticated user hits a protected
   * route. We accept any string so the caller can include search
   * params in the target.
   */
  redirect: z.string().optional(),
  /**
   * Optional pre-fill. When present the page auto-submits to
   * preflight so operators following a one-click email link don't
   * have to retype their address.
   */
  email: z.string().optional(),
});

type LoginSearch = z.infer<typeof loginSearchSchema>;

export const Route = createFileRoute("/login")({
  validateSearch: (raw: Record<string, unknown>): LoginSearch => loginSearchSchema.parse(raw),
  component: AdminLoginPage,
});
